/**
 * What to tell the operator about the email a newly registered user was, or was not, sent.
 *
 * Read off the API's answer rather than worked out here, and deliberately. Whether a Microsoft work account can
 * sign in for a company depends on two things the browser cannot see — the administrator's approval and the
 * directory allowlist — and they fail in completely different ways, so the reasons are composed server-side by
 * the code that checked them. "held" is not an error: the user exists and the only thing outstanding is an
 * email, which is why the wording says what is waiting rather than what went wrong.
 *
 * Shared by Add New User and the Primary Contact on Account Creation, the two places a portal user is registered.
 *
 * @param {Object} created - the created user as the API returned it, including its `invitation` block
 * @param {Object} [wording]
 * @param {string} [wording.saved] - what was saved, leading every sentence: "User added", "Primary contact saved"
 * @param {string} [wording.fallback] - said when no email was due or the API predates invitations
 * @returns {string}
 */
export function describeInvitation(created, {saved = "User added", fallback = "User added successfully"} = {}) {
    const invitation = created?.invitation;

    if (invitation?.status === "held") {
        return `${saved}. No sign-in email was sent yet: ${(invitation.blockers ?? []).join(" and ")}.`;
    }
    if (invitation?.status === "sent") return `${saved} and sign-in instructions emailed.`;

    // "skipped" (a TapeArk user with no company, or someone already invited), or an API that predates this.
    return fallback;
}
